import api from '../api/icaro';

export async function baixaItensEstoque(itens) {

  const { data } = await api.post('/vendas/itens', itens);
  return data;
}
